/* globals femcare */

femcare.product.panel.info.default = {
    $mainPanel: $('.product-main').not('.product-main--shop'),
    mediaPanel: null,

    init: function () {
        if (this.$mainPanel.length) {
            this.mediaPanel = femcare.product.panel.media;
            this.mediaPanel.init(this.$mainPanel);
        }
        this.initTooltips();
        this.initReadMore();
    },

    initTooltips: function () {
        var $flowMetrics = $('.product-metric__info');

        if ($flowMetrics.length){
            $flowMetrics.each(function (index, element) {
                var $flowMetric = $(element);
                var flowContent = $flowMetric.find('.product-metric-tooltip')[0].outerHTML;
    
                $flowMetric.tooltip({
                    items: $flowMetric,
                    content: flowContent,
                    classes: {
                        'ui-tooltip': 'tooltip',
                        'ui-tooltip-content': 'tooltip__content'
                    }
                });
            });
        }
    },

    initReadMore: function() {
        var maxLength = 250;
        var $description = $('.product-main__info-panel .product-main__description');

        if ($description.length) {
            var descriptionText = $description.html();
        
            var shortStr = descriptionText.substring(0, maxLength);
            var parser = new DOMParser();
            var parsedText = parser.parseFromString(descriptionText, "text/html");
            var parsedHtml = parsedText.activeElement;
            
            var $readMoreLessCta = $('.product-main__description-cta');
            var $readMoreLessButton = $readMoreLessCta.find('a');
    
            if (descriptionText.length > maxLength){
                $readMoreLessCta.removeClass('hidden');

                var descFullHeight = $description.height();
                $description.empty().html(shortStr);
                var descShortHeight = $description.height();
                $description.html(parsedHtml).css('height', descShortHeight);

                $readMoreLessButton.on('click', function(e) {
                    e.preventDefault();
                    var $button = $(this);
                    $readMoreLessButton.toggle();

                    if($button.hasClass('product-main__read-more')) {
                        $description.animate({'height': descFullHeight}, {duration: 500});
                    } else {
                        $description.animate({'height': descShortHeight}, {duration: 500});
                    }
                })
            }
        }
    }
}
